import React, { Component } from 'react';
import { Button, Modal, Card } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search, CSVExport } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import { Fetcher } from "../../Helpers/fetcher.js";
import { Notify } from "../../Helpers/notification.js";
import ReactTooltip from 'react-tooltip';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import Cookies from 'js-cookie';

import "./index.css";
class CLIManagement extends Component {
	constructor(props) {

		super(props);
		this.state = {
			cliList: [],
			confirmDelete: false,
			confirmBulkDelete: false,
			selectedCliId: 0,
			showAddCreditModal: false,
			showModal: false,
			modalHeading: 'Status',
			modalContent: '',
			cliType: 'dedicated_cli',
			sizePerPage: 10,
			selectedRows: []
		}
	}
	componentDidMount() {
		this.getCli();
		const savedSizePerPage = Cookies.get('cliListsizePerPage');
		if (savedSizePerPage) {
			this.setState({ sizePerPage: Number(savedSizePerPage) });
		}
	}


	getCli = () => {
		const apiPath = this.props.app.apiPath;
		let userId = '';
		if (this.props.app.role === 'ROLE_SADMIN') {
			userId = this.props.app.userId;
		}
		else if (this.props.app.role === 'ROLE_ADMIN') {
			userId = this.props.app.userId;
		}

		const endpoint = this.state.cliType === 'cli' ? '/api/obd/cli/' : '/api/obd/cli/dedicated/';
		Fetcher.get(apiPath + endpoint + userId)
			.then(res => {
				this.setState({
					cliList: res,
					showModal: false,
					showAddCreditModal: false,
					confirmDelete: false,
				})
			})
			.catch(err => { console.log('Error in fetching CLI List', err) });
	}

	confirmDelete = (status, cliId) => {
		this.setState({
			confirmDelete: status,
			selectedCliId: cliId
		});
	}

	deleteCli = () => {
		const cliId = this.state.selectedCliId;
		let allocated = 0;
		if (this.props.app.role === 'ROLE_SADMIN') {
			allocated = 1;
		}
		else if (this.props.app.role === 'ROLE_ADMIN') {
			allocated = 2;
		}
		const data = {
			cliId: cliId,
			userId: this.props.app.userId,
			allocated: allocated
		}

		return Fetcher.post(this.props.app.apiPath + '/api/obd/cli', { headers: { "Content-type": "application/json" }, method: 'DELETE', body: JSON.stringify(data) })
			.then(res => {
				Notify.notify(res.message);
				this.getCli();
			})
			.catch(err => {
				console.log('Error in Deleting CLI', err);
				Notify.notify('Error in Deleting CLI');
			});

	}

	setvalue = (e) => {
		this.setState({
			[e.target.name]: e.target.value,
		});
	}

	setMessageShow = (status) => {
		this.setState({
			showModal: false,
			showAddCreditModal: false,
		});
	}

	showAddCreditModal = (userId) => {
		this.setState({
			showAddCreditModal: true,
			selectedCliId: userId
		});
	}

	toggleCliType = () => {
		const newCliType = this.state.cliType === 'cli' ? 'dedicated_cli' : 'cli';
		this.setState({ cliType: newCliType }, this.getCli);
	}

	handleSizePerPageChange = (newSizePerPage) => {
		this.setState({ sizePerPage: newSizePerPage });
		Cookies.set('cliListsizePerPage', newSizePerPage);
	}

	deleteSelectedClis = () => {
		const { selectedRows } = this.state;

		if (!selectedRows.length) return;

		const payload = {
			filterData: selectedRows.join(',')
		};

		Fetcher.post(
			this.props.app.apiPath + '/api/obd/bulk/delete/cli',
			{
				headers: {
					'Content-Type': 'application/json',
				},
				method: "POST",
				body: JSON.stringify(payload)
			}
		)
			.then(res => {
				Notify.notify(res.message || 'Selected CLIs deleted successfully');
				this.setState({ selectedRows: [] });
				this.getCli();
			})
			.catch(err => {
				console.error('Bulk delete error', err);
				Notify.notify('Error deleting selected CLIs');
			});
	};

	render() {

		const cliList = this.state.cliList;
		const { cliType } = this.state;
		var columns;
		if (this.props.app.role === 'ROLE_SADMIN') {
			columns = [
				{
					dataField: 'cliId',
					text: 'CLI Id',
					sort: true,
					hidden: false
				},
				{
					dataField: 'cli',
					text: 'CLI',
					sort: true,
					searchable: true
				},
				{
					dataField: 'cliStatus',
					text: 'Status',
					sort: true,
					searchable: true
				},
				{
					dataField: 'dialerName',
					text: 'Dialer',
					sort: true,
					searchable: true
				},
				{
					dataField: 'pilotNumber',
					text: 'Pilot Number',
					sort: true,
					searchable: true
				},
				...(cliType === 'dedicated_cli' ? [{ dataField: 'userName', text: 'Username', sort: true, searchable: true }] : []),
				...(cliType === 'dedicated_cli' ? [{ dataField: 'allocationDate', text: 'Allocation Date', sort: true, searchable: false }] : []),
				{
					dataField: 'action',
					text: 'Action',
					sort: false,
					searchable: false
				}];
		}
		else {
			columns = [
				{
					dataField: 'cliId',
					text: 'CLI Id',
					sort: true,
					hidden: false
				},
				{
					dataField: 'cli',
					text: 'CLI',
					sort: true,
					searchable: true
				},
				{
					dataField: 'dialerName',
					text: 'Dialer',
					sort: true,
					searchable: true
				},
				{
					dataField: 'pilotNumber',
					text: 'Pilot Number',
					sort: true,
					searchable: true
				},
				...(cliType === 'dedicated_cli' ? [{ dataField: 'userName', text: 'Username', sort: true, searchable: true }] : []),
				...(cliType === 'dedicated_cli' ? [{ dataField: 'allocationDate', text: 'Allocation Date', sort: true, searchable: false }] : [])
				/*{
					dataField: 'action',
					text: 'Action',
					sort: false,
					searchable: false
				},*/];
		}
		const clis = Array.isArray(cliList) ? cliList.map((cli, index) => {
			let status = '';
			switch (cli.cliStatus) {
				case 1:
					status = 'Unarchived';
					break;
				case 2:
					status = 'Archived';
					break;
				default:
					status = '';
					break;
			}
			let action = '';
			if (this.props.app.role === 'ROLE_SADMIN') {
				action = [<a data-tip="Delete CLI" key={`${index}-delete-cli`} className="delete-cli" onClick={(e) => { this.confirmDelete(true, cli.cliId) }} href="#"><i className="fa fa-trash"></i></a>];
				//let action = [ <Link data-tip="Edit CLI" key={`${index}-edit-cli`} className="edit-cli" to={`${this.props.app.urlPrefix}/update-cli/${cli.cliId}`}><i className="fa fa-edit"></i></Link> ];
				//let action = [<a data-tip="Delete CLI" key={`${index}-delete-cli`} className="delete-cli" onClick={(e) => { this.confirmDelete(true, cli.cliId) }} href="#">Deallocate CLI</a>];
				//action.push( <a data-tip="Delete CLI" key={`${index}-delete-cli`} className="delete-cli" onClick={( e ) => { this.confirmDelete( true, cli.cliId ) }} href="#"><i className="fa fa-trash"></i></a> )
				return {
					cliId: cli.cliId,
					cli: cli.cli,
					cliStatus: status,
					dialerName: cli.dialerName,
					pilotNumber: cli.pilotNumber,
					userName: cli.cliStatus === 2 ? cli.userName : cli.resellerUsername,
					allocationDate: cli.allocationDate ?? '',
					action: action
				};
			}
			else {
				//let action = [<a data-tip="Delete CLI" key={`${index}-delete-cli`} className="delete-cli" onClick={(e) => { this.confirmDelete(true, cli.cliId) }} href="#">Deallocate CLI</a>];
				//let action = [ <Link data-tip="Edit CLI" key={`${index}-edit-cli`} className="edit-cli" to={`${this.props.app.urlPrefix}/update-cli/${cli.cliId}`}><i className="fa fa-edit"></i></Link> ];
				//action.push( <a data-tip="Delete CLI" key={`${index}-delete-cli`} className="delete-cli" onClick={( e ) => { this.confirmDelete( true, cli.cliId ) }} href="#"><i className="fa fa-trash"></i></a> )
				return {
					cliId: cli.cliId,
					cli: cli.cli,
					cliStatus: status,
					dialerName: cli.dialerName,
					pilotNumber: cli.pilotNumber,
					userName: cli.cliStatus === 2 ? cli.userName : cli.resellerUsername,
					allocationDate: cli.allocationDate ?? '',
					//action: action
				};
			}
		}) : []
		const { SearchBar, ClearSearchButton } = Search;
		const { ExportCSVButton } = CSVExport;

		const defaultSorted = [{
			dataField: 'allocationDate',
			order: 'desc'
		}];

		const paginationOption = {
			custom: true,
			totalSize: clis.length,
			sizePerPage: this.state.sizePerPage,
			sizePerPageList: [10, 25, 50, 100],
			onSizePerPageChange: this.handleSizePerPageChange
		};
		const selectRow = {
			mode: 'checkbox',
			clickToSelect: false,
			selected: this.state.selectedRows,
			onSelect: (row, isSelect) => {
				if (isSelect) {
					this.setState(prev => ({
						selectedRows: [...prev.selectedRows, row.cliId]
					}));
				} else {
					this.setState(prev => ({
						selectedRows: prev.selectedRows.filter(id => id !== row.cliId)
					}));
				}
			},
			onSelectAll: (isSelect, rows) => {
				if (isSelect) {
					const allIds = clis.map(cli => cli.cliId);
					this.setState({ selectedRows: allIds });
				} else {
					this.setState({ selectedRows: [] });
				}
			},
			selectColumnStyle: { paddingLeft: '12px' },
			headerColumnStyle: { paddingLeft: '12px' },
		};

		return (
			<Card>
				{/*<Card.Header>Users List<span>&nbsp;&nbsp;&nbsp;</span><span className="float-none avail-credit-cont"><span className="credits-avail">Available Credits: {this.state.adminCredits}</span></span></Card.Header>*/}
				<Card.Header>
					{cliType === 'cli' ? 'CLI List' : 'Dedicated CLI List'}
					{this.props.app.role === 'ROLE_SADMIN' &&
						<Button onClick={this.toggleCliType} className="ml-3">
							{cliType === 'cli' ? 'Show Dedicated CLI List' : 'Show CLI List'}
						</Button>
					}
				</Card.Header>
				<Card.Body>
					<div className="widget-list-table-cont">
						{/* <h3>Campaign Summary</h3> */}
						{/*{!isEmpty( this.state.cliList ) && <PaginationProvider pagination={paginationFactory( paginationOption )}>*/}
						{<PaginationProvider pagination={paginationFactory(paginationOption)}>
							{
								({
									paginationProps,
									paginationTableProps
								}) => (
									<ToolkitProvider
										keyField="cliId"
										data={clis}
										columns={columns}
										search
										bootstrap4
										exportCSV={{
											fileName: 'cli.csv'
										}}

									>
										{
											props => (
												<div className="">
													Show <SizePerPageDropdownStandalone className="search-dropdown" {...paginationProps} /> items
													<span className="search-cont"><SearchBar  {...props.searchProps} /></span>
													<ClearSearchButton className="btn-primary btn-round" {...props.searchProps} />
													<ExportCSVButton className="export-csv btn-primary ml-2" {...props.csvProps}>Export to CSV</ExportCSVButton>
													{this.state.selectedRows.length > 0 && (
														<Button
															variant="danger"
															className="float-right ml-2"
															onClick={() => this.setState({ confirmBulkDelete: true })}

														>
															Delete Selected CLI ({this.state.selectedRows.length})
														</Button>
													)}
													{/*<span>&nbsp;&nbsp;&nbsp;</span><span className="float-none avail-credit-cont"><span className="credits-avail">Available Credits: {this.state.adminCredits}</span></span>*/}
													{/*<Link className="float-right btn btn-default btn-primary" to={`${this.props.app.urlPrefix}/add-cli`}>Allocate CLI</Link>*/}

													<BootstrapTable defaultSorted={defaultSorted} bordered={true} hover condensed wrapperClasses="table-responsive" classes="mt-3  widgetlist-table"  {...props.baseProps}  {...paginationTableProps} noDataIndication={() => (<div>{'No data available'}</div>)} selectRow={selectRow} />
													<PaginationListStandalone {...paginationProps} />
													<ReactTooltip />
												</div>
											)
										}
									</ToolkitProvider>
								)
							}
						</PaginationProvider>}
					</div>

					<Modal size="sm" show={this.state.showModal} onHide={() => this.setMessageShow(false)}>
						<Modal.Header closeButton>
							<Modal.Title id="example-modal-sizes-title-sm">
								{this.state.modalHeading}
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>{this.state.modalContent}</Modal.Body>
					</Modal>

					<Modal
						size="md"
						show={this.state.confirmBulkDelete}
						onHide={() => this.setState({ confirmBulkDelete: false })}
					>
						<Modal.Header closeButton>
							<Modal.Title>
								Delete Selected CLIs
							</Modal.Title>
						</Modal.Header>

						<Modal.Body>
							Are you sure you want to delete
							<strong> {this.state.selectedRows.length} </strong>
							selected CLIs?
						</Modal.Body>

						<Modal.Footer>
							<Button
								variant="secondary"
								onClick={() => this.setState({ confirmBulkDelete: false })}
							>
								CANCEL
							</Button>

							<Button
								variant="danger"
								onClick={() => {
									this.setState({ confirmBulkDelete: false });
									this.deleteSelectedClis();
								}}
							>
								YES, DELETE
							</Button>
						</Modal.Footer>
					</Modal>

					<Modal size="md" show={this.state.confirmDelete} onHide={() => this.confirmDelete(false, '')}>
						<Modal.Header closeButton>
							<Modal.Title id="example-modal-sizes-title-sm">
								Delete CLI
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							Are you sure you want to delete this CLI?
						</Modal.Body>
						<Modal.Footer>
							<Button onClick={() => this.confirmDelete(false, '')} variant="secondary">CANCEL</Button>
							<Button onClick={this.deleteCli} variant="primary">YES</Button>
						</Modal.Footer>
					</Modal>

				</Card.Body>
			</Card>

		);
	}
}

export default CLIManagement;